/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListChevronsUpDown = [
  ["path", { d: "M3 5h8" }],
  ["path", { d: "M3 12h8" }],
  ["path", { d: "M3 19h8" }],
  ["path", { d: "m15 8 3-3 3 3" }],
  ["path", { d: "m15 16 3 3 3-3" }]
];

export { ListChevronsUpDown as default };
//# sourceMappingURL=list-chevrons-up-down.js.map
